import { render } from "./beanStrategy.vue?vue&type=template&id=c899101a"
import script from "./beanStrategy.vue?vue&type=script&lang=js"
export * from "./beanStrategy.vue?vue&type=script&lang=js"

import "./beanStrategy.vue?vue&type=style&index=0&id=c899101a&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__